"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LvFlowProgressBarSettings = void 0;
var commonFunctions_1 = require("../../commonFunctions");
/**
 * This class is responsible for page progress bar configuration.
 *
 * It contains an array of pages where you want to display progress.
 * The sequence of items corresponds to the displayed progress.
 * The number of array elements is the total number of progress steps.
 */
var LvFlowProgressBarSettings = /** @class */ (function () {
    function LvFlowProgressBarSettings() {
        this.REGISTRATION_PAGE = "REGISTRATION_PAGE";
        this.REGISTRATION_CONFIRMATION_PAGE = "REGISTRATION_CONFIRMATION_PAGE";
    }
    LvFlowProgressBarSettings.prototype.setKeycloakPageProgressCookies = function () {
        (0, commonFunctions_1.setCookie)("registration_page_progress_bar_percentage", this.getPercentageByPageId(this.REGISTRATION_PAGE));
        (0, commonFunctions_1.setCookie)("registration_confirmation_page_progress_bar_percentage", this.getPercentageByPageId(this.REGISTRATION_CONFIRMATION_PAGE));
    };
    /**
     * Return number 0-100 as percents of progress bar current page progress
     * @param stepsToPageIdsMap
     * @param pageId
     */
    LvFlowProgressBarSettings.prototype.getPercentageInMapByPageId = function (stepsToPageIdsMap, pageId) {
        var pageIdNoDigits = pageId.replace(new RegExp("[0-9]", "g"), "");
        for (var i = 0, length_1 = stepsToPageIdsMap.length; i < length_1; i++) {
            if (stepsToPageIdsMap[i].includes(pageIdNoDigits)) {
                return (i + 1) / length_1 * 100;
            }
        }
        return null;
    };
    return LvFlowProgressBarSettings;
}());
exports.LvFlowProgressBarSettings = LvFlowProgressBarSettings;
//# sourceMappingURL=LvFlowProgressBarSettings.js.map